import Model from '../models'
import API from '../../api'

Model.Availability.createAction('FETCH_ITEM_AVAILABILITY', (options) => {
  return API.get('item_availabilities', options)
})

Model.Availability.createAction('FETCH_CALENDAR_AVAILABILITY', (options) => {
  return API.get('cart_availabilities', options)
})

export default Model.Availability.actions
